import type { QueryFilter } from '@domain/types/filters';

import type { FilterRow } from '../types';

const noValuesNeeded = (comparator: string) => comparator === 'ex' || comparator === 'nex';

export const isRowComplete = (row: FilterRow): boolean =>
  row.field !== '' && row.comparator !== '' && (row.values.length > 0 || noValuesNeeded(row.comparator));

export const deriveQueryFilters = (rows: FilterRow[]): QueryFilter[] =>
  rows
    .filter(isRowComplete)
    .map(({ field, comparator, values }) => ({ field, comparator: comparator as QueryFilter['comparator'], values }));

export const deriveActiveCount = (rows: FilterRow[]): number => rows.filter(isRowComplete).length;
